import React from 'react'
import { useRouter } from 'next/router'
import View from './view'

import { throttle } from 'utils'

const SearchMapsInput = (props) => {
  const router = useRouter()

  const handleChange = (event) => {
    throttle(() => {
      const value = event.target.value

      const newQuery = { ...router.query, page: 1 }
      if (!value?.length) delete newQuery.query
      else newQuery.query = value

      router.replace({ query: newQuery }, undefined, {
        shallow: true
      })
    }, 500)
  }

  return (
    <View
      {...props}
      defaultValue={router.query?.query || ''}
      onChange={handleChange}
    />
  )
}

export { SearchMapsInput }
export default SearchMapsInput
